import { Box } from "@mui/material";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import Footer from "./components/Footer";
import Header from "./components/Header";
import ScrollToTop from "./components/ScrollToTop";
import Accueil from "./pages/Accueil";
import Error from "./pages/Error";
import Faq from "./pages/Faq";
import FemmeEnceinte from "./pages/FemmeEnceinte";
import MentionLegal from "./pages/MentionLegal";
import Cabinets from "./pages/Cabinets";
import Drainage from "./pages/Drainage";
import HernieDiscale from "./pages/HernieDiscale";
import Sciatique from "./pages/Sciatique";
import Tendinite from "./pages/Tendinite";
import Nourrissons from "./pages/Nourrissons";
import Partenaires from "./pages/Partenaires";
import Pathologies from "./pages/Pathologies";
import Sportifs from "./pages/Sportifs";
import TarifsetRemboursements from "./pages/TarifsRemboursements";
import VotreOsteopathe from "./pages/VotreOsteopathe";

function App() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Box component="main" sx={{ flex: 1 }}>
        <Routes>
          {/* Routes canoniques kebab-case */}
          <Route path="/" element={<Accueil />} />
          <Route path="/votre-osteopathe" element={<VotreOsteopathe />} />
          <Route path="/pathologies" element={<Pathologies />} />
          <Route
            path="/pathologies/femme-enceinte"
            element={<FemmeEnceinte />}
          />
          <Route path="/pathologies/nourrissons" element={<Nourrissons />} />
          <Route path="/pathologies/sportifs" element={<Sportifs />} />
          <Route
            path="/pathologies/drainage-lymphatique"
            element={<Drainage />}
          />
          <Route path="/pathologies/sciatique" element={<Sciatique />} />
          <Route path="/pathologies/hernie-discale" element={<HernieDiscale />} />
          <Route path="/pathologies/tendinite" element={<Tendinite />} />
          <Route path="/cabinets" element={<Cabinets />} />
          <Route
            path="/tarifs-et-remboursements"
            element={<TarifsetRemboursements />}
          />
          <Route path="/faq" element={<Faq />} />
          <Route path="/mentions-legales" element={<MentionLegal />} />
          <Route path="/partenariats" element={<Partenaires />} />

          {/* Redirections depuis les anciennes URLs PascalCase */}
          <Route
            path="/VotreOsteopathe"
            element={<Navigate to="/votre-osteopathe" replace />}
          />
          <Route
            path="/Pathologies"
            element={<Navigate to="/pathologies" replace />}
          />
          <Route
            path="/Pathologies/femme-enceinte"
            element={<Navigate to="/pathologies/femme-enceinte" replace />}
          />
          <Route
            path="/Pathologies/nourrissons"
            element={<Navigate to="/pathologies/nourrissons" replace />}
          />
          <Route
            path="/Pathologies/sportifs"
            element={<Navigate to="/pathologies/sportifs" replace />}
          />
          <Route
            path="/Cabinets"
            element={<Navigate to="/cabinets" replace />}
          />
          <Route
            path="/TarifsetRemboursements"
            element={<Navigate to="/tarifs-et-remboursements" replace />}
          />
          <Route path="/FAQ" element={<Navigate to="/faq" replace />} />
          <Route
            path="/MentionLegal"
            element={<Navigate to="/mentions-legales" replace />}
          />

          <Route path="/*" element={<Error />} />
        </Routes>
        </Box>
        <Footer />
      </BrowserRouter>
    </Box>
  );
}

export default App;
